import React, { PureComponent } from "react";
import iconv from "iconv-lite";
import isNil from "lodash/isNil";

import { saveFile } from "./helpers/FileHelper";

export function CSVWrapper(ComponentToWrap) {
    return class WrappedComponent extends PureComponent {
        processRow = row =>
            row
                .map(column => {
                    let result = (isNil(column) ? "" : column).toString().replace(/"/g, '""');
                    if (result.search(/("|,|\n)/g) >= 0) {
                        result = `"${result}"`;
                    }
                    return result;
                })
                .join(",")
                .concat("\n");

        exportToCsv = (filename, rows) => {
            const csv = rows.map(row => this.processRow(row)).join("");
            const blob = new Blob([iconv.encode(csv, "ISO-8859-1")], {
                type: "text/csv;charset=ISO-8859-1;"
            });
            saveFile(blob, filename);
        };

        render() {
            return <ComponentToWrap {...this.props} exportToCsv={this.exportToCsv} />;
        }
    };
}
